import { useGlobalTopicFavoriteListModel } from './global-topic-favorite-list.model'
import { GlobalTopicFavoriteListView } from './global-topic-favorite-list.view'

export const GlobalTopicFavoriteList = () => {
  const globalTopicFavoriteListModel = useGlobalTopicFavoriteListModel()
  return <GlobalTopicFavoriteListView {...globalTopicFavoriteListModel} />
}
